
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.cart-upsell-add');

  if (!button || button.disabled) return;

  event.preventDefault();

  const variantId = button.dataset.upsellVariantId;
  if (!variantId) return;

  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = 'Adding...';

  try {
    const root = window.Shopify?.routes?.root || '/';

    const addResponse = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname
      })
    });

    const addedItem = await addResponse.json();

    if (!addResponse.ok) {
      throw new Error(addedItem.description || 'Could not add product.');
    }

    const cartResponse = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!cartResponse.ok) {
      throw new Error('Could not refresh cart.');
    }

    const cart = await cartResponse.json();

    const update = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ id: Number(variantId), quantity: 1 }],
        promise: update.promise
      })
    );

    update.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse({
        ...cart,
        sections: addedItem.sections
      }),
      detail: {
        sections: addedItem.sections,
        items: cart.items,
        itemCount: cart.item_count,
        source: 'cart-upsell',
        didError: false
      }
    });

  } catch (error) {
    console.error('Cart upsell error:', error);
    alert(error.message || 'Something went wrong. Please try again.');
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
});
